import { FeeType } from 'types/fees';

export const FEES_PRICING_TYPES = {
  ALL_INCLUSIVE: 1,
  POINTS: 2,
  LEVELS: 3,
  UNKNOWN: 4,
  A_LA_CARTE: 5,
};

export const FEES_PRICING_TYPES_LABELS = {
  [FEES_PRICING_TYPES.ALL_INCLUSIVE]: 'All-Inclusive',
  [FEES_PRICING_TYPES.POINTS]: 'Points',
  [FEES_PRICING_TYPES.LEVELS]: 'Levels',
  [FEES_PRICING_TYPES.UNKNOWN]: 'Unknown',
  [FEES_PRICING_TYPES.A_LA_CARTE]: 'A La Carte',
};

export const FEES_TYPE_LABELS: Record<FeeType, string> = {
  [FeeType.CARE_FEE]: 'Care Fees',
  [FeeType.MEDICATION_FEE]: 'Medication Fees',
};

export const FEES_TYPE_PRICING_TYPES: Record<FeeType, number[]> = {
  [FeeType.CARE_FEE]: [
    FEES_PRICING_TYPES.ALL_INCLUSIVE,
    FEES_PRICING_TYPES.POINTS,
    FEES_PRICING_TYPES.LEVELS,
    FEES_PRICING_TYPES.UNKNOWN,
    FEES_PRICING_TYPES.A_LA_CARTE,
  ],
  [FeeType.MEDICATION_FEE]: [FEES_PRICING_TYPES.ALL_INCLUSIVE, FEES_PRICING_TYPES.LEVELS, FEES_PRICING_TYPES.UNKNOWN],
};
